var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class:
        (_vm.numberShow === _vm.indexNumber && !_vm.longImage) ||
        _vm.isSearch === true
          ? "index"
          : "",
      style: _vm.longImage ? "overflow-y: hidden;" : "",
      attrs: { id: "app" },
    },
    [
      _vm.isSearch
        ? _c("SearchDialog", {
            staticClass: "report",
            attrs: { show: _vm.isSearch },
            on: {
              "update:show": function ($event) {
                _vm.isSearch = $event
              },
            },
          })
        : _vm._e(),
      _vm.numberShow === _vm.indexNumber
        ? _c("Index")
        : _vm.numberShow === _vm.albumNumber ||
          _vm.numberShow === _vm.albumNumber + 9
        ? _c("album")
        : _c("error", { ref: "errorRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }